import { useState } from 'react';
//import InputForm from '../../../InputT';
import InputForm from '../../InputT';
import { useTranslation } from 'react-i18next';
//import DataType from '../../../../Types/DataTablePiclist';
import DataType from '../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import Table, { ColumnsType } from 'antd/es/table';
//import Utilisateur from '../../../../Models/Utilisateur';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';    
//import { number } from 'yup';
import { Badge, Form, Input, Space, Typography } from 'antd';
//import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
//import DataHistoCpt from '../../../../Types/DataHistoCpt';
import DataHistoCpt from '../../../Types/DataHistoCpt';
import Search from 'antd/es/input/Search';
//import Data from '../../../Data/Data.json';


const Swal = require('sweetalert2');
let Link = require('../../../Data/Data.json');

const Tab2 = (props: { form?: any, DataOperation: DataHistoCpt[] }) => {

    const datas: DataType[] = [];
    //const {t,i18n}=useTranslation();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader();
    const [SearchR, SetSearchR] = useState<string>("");


    const columns: ColumnsType<DataHistoCpt> = [
        {
            title: 'DateOpe',
            dataIndex: 'DATOPE',
            ellipsis: true,
            width: 100,
            render: (text: any, reccord: any) => (
                <span>
                    {ReformatDate(text)}
                </span>
            )
        },
        {
            title: 'Heure',
            dataIndex: 'TIME',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCPT)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.SENSEC)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.REPECE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.MONTANT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.LIBELL)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.DATOPE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NBENEF)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.TIME)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.UTISAI)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            ellipsis: true,
            width: 100,
            title: 'Sens',
            dataIndex: 'SENSEC',
            align: 'center',
            render: (text: any, reccord: any) => (
                <Box   >
                    <Badge style={{ textAlign: 'center' }} status='success' color={reccord.SENSEC == "C" ? '#116599' : reccord.SENSEC == "D" ? 'red' : 'orange'} size='default' count={reccord.SENSEC == "D" ? 'Debit' : reccord.SENSEC == "C" ? 'Credit' : 'No sence'}> </Badge>
                </Box>
            )
        },
        {
            title: 'Reférence',
            dataIndex: 'REPECE',
            ellipsis: true,
            width: 150,
        }
        ,
        {
            title: 'REFLIAI',
            dataIndex: 'REFLIAI',
            ellipsis: true,
            width: 100,
        },

        {
            title: 'Montant',
            dataIndex: 'MONTANT',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Beneficiare',
            dataIndex: 'NBENEF',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Utisai',
            dataIndex: 'UTISAI',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Utival',
            dataIndex: 'UTIVAL',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Lebelle',
            dataIndex: 'LIBELL',
            ellipsis: true,
            width: 200,
        },
        {
            title: "",
            dataIndex: 'RelObject',
            width: 1
        }
    ];

    return (
        <div className='tabItem' >
            <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
                <Box display={'flex'} justifyContent={'space-between'} gap={'50%'} marginBottom={'0.5%'}>
                    <Typography></Typography>
                    <Search disabled={false} size='middle' placeholder="Search Here" onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} />
                </Box>
                <Box >
                    <Table sticky={true} columns={columns} size='small' pagination={false} style={{ width: '100%' }} scroll={{ y:300, x: 20 }} dataSource={props.DataOperation} />
                </Box>
                <Box display={"flex"} width={"98%"} marginTop={"5px"} fontStyle="inherit">
                    <Space.Compact >
                        <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
                        <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
                    </Space.Compact>
                    <Space.Compact >
                        <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebit'><Input disabled /></Form.Item>
                        <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
                    </Space.Compact>
                    <Space.Compact >
                        <Form.Item label="Solde Total" name='Solde'><Input disabled /></Form.Item>
                    </Space.Compact>
                </Box>
            </Box>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default Tab2;
